import { AgreementStatus } from "../agreements/agreement";
import { IvaCondition } from "../invoices/invoice";
import { BillingFrequency } from "../offerings/offering";

export enum PaymentStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  REFUNDED = 'refunded',
  CANCELLED = 'cancelled',
  IN_COLLECTOR = 'in_collector',
}

export enum PaymentMethod {
  CREDIT_CARD = 'credit_card',
  DEBIT_CARD = 'debit_card',
  BANK_TRANSFER = 'bank_transfer',
  CASH = 'cash',
  OTHER = 'other',
}

export enum PaymentSource {
  Subscription = 'subscription',
  Installment = 'installment',
  Direct = 'direct',
}

export const formatPaymentMethod = (method: PaymentMethod): string => {
  switch (method) {
    case PaymentMethod.CASH:
      return 'Efectivo'
    case PaymentMethod.CREDIT_CARD:
      return 'Tarjeta de crédito'
    case PaymentMethod.DEBIT_CARD:
      return 'Tarjeta de débito'
    case PaymentMethod.BANK_TRANSFER:
      return 'Transferencia bancaria'
    case PaymentMethod.OTHER:
      return 'Otro'
    default:
      return method
  }
}

export const formatPaymentMethodShortName = (method: PaymentMethod): string => {
  switch (method) {
    case PaymentMethod.CASH: return 'Efectivo'
    case PaymentMethod.CREDIT_CARD: return 'Tja Crédito'
    case PaymentMethod.DEBIT_CARD: return 'Tja Débito'
    case PaymentMethod.BANK_TRANSFER: return 'Transferencia'
    case PaymentMethod.OTHER: return 'Otro'
    default: return method
  }
}

export enum Currency {
  ARS = 'ARS',
  USD = 'USD',
}

export interface CreatePaymentTransactionData {
  userId: string;
  amount: number;
  status: PaymentStatus;
  currency: Currency;
  paymentMethod: PaymentMethod;
  paymentMethodDetails?: any;
}

export interface UpdatePaymentTransactionData {
  paymentMethod?: PaymentMethod;
  paymentMethodDetails?: any;
  amount?: number;
  collectorId?: string | null;
  status?: PaymentStatus;
}

export interface PaymentMethodDetails {
  obs?: string;
}

export interface PaymentTransaction {
  id: string;
  userId: string;
  amount: number;
  currency: Currency;
  status: PaymentStatus;
  paymentMethod: PaymentMethod;
  paymentMethodDetails: PaymentMethodDetails;
  generatedDate: Date;
  paymentDate: Date;
  mainPaymentId: string;
  collectorId?: string | null;
  interestSum: number;
  createdBy: string;
  paymentPeriodStartDate?: Date;
  paymentPeriodEndDate?: Date;
  description?: string
}

export interface PaymentData {
  contractId: string,
  contractNumber: string,
  contractAmount: number,
  status: AgreementStatus,
  offeringCode: string,
  offeringName: string,
  contractStartDate: Date,
  contractEndDate: Date | null,
  sellerId?: string | null,
  payments: PaymentTransaction[],
}

export interface AgreementPayment {
  contractId: string;
  mainContractId?: string | null;
  paymentId: string;
  currency: string;
  totalAmount: number;
  contractNumber: string;
  offeringCode: string;
  offeringName: string;
  taxRate: number;
  billingFrequency: BillingFrequency;
  contractAmount: number;
  requestedDate?: Date;
  periodStartDate?: Date;
  periodEndDate?: Date;
  paymentPeriodFrom?: Date;
  description?: string
}

export interface AgreementCustomer {
  customerName: string;
  customerCode: string;
  customerDocType: string;
  customerDocNumber: string;
  customerAddress: string;
  customerIvaCondition: IvaCondition;
  payerName?: string,
  payerCode?: string,
  payerDocType?: string,
  payerDocNumber?: string,
  payerAddress?: string,
}
